import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';

import { helper } from 'src/environments/helper';
import { Generic } from 'src/app/interfaces/generic.interface';
import { UsersService } from '../../../../settings-sidenav/users-settings/users.service';
import { ClientModulesService } from '../client-modules.service';
import { ModulesService } from '../../../../administration/admin-settings/modules/modules.service';

@Component({
    selector: 'app-edit-client-module',
    templateUrl: './edit-client-module.component.html',
    styleUrls: ['./edit-client-module.component.scss'],
})
export class EditClientModuleComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    modulesActive$!: Observable<{ module_id: number, display_name: string }[]>;

    isLoading = false;

    form: FormGroup = new FormGroup({
        id: new FormControl(this.data.id, [Validators.required]),
        client_id: new FormControl(this.data.id_client, [Validators.required]),
        module_id: new FormControl('', [Validators.required]),
        display_name: new FormControl('', [Validators.required]),
        url_front_end: new FormControl('', [Validators.required]),
        url_back_end: new FormControl('', [Validators.required]),
    });
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<EditClientModuleComponent>,
        public clientModulesService: ClientModulesService,
        public usersService: UsersService,
        private modulesService: ModulesService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) { }

    ngOnInit(): void {
        this.loadModulesActive();
        this.getClientModuleDetails();
    }

    loadModulesActive() {
        this.isLoading = true;
        this.modulesActive$ = this.modulesService.getModuleActive()
            .pipe(
                map((response: any) =>
                    response.data.map((m: any) => ({ module_id: m.id, display_name: m.name }))
                ),
                finalize(() => { this.isLoading = false; }));
    }

    getClientModuleDetails() {
        this.isLoading = true;

        this.clientModulesService.getClientModuleById(this.data.id).pipe(
            finalize(() => {
                this.isLoading = false;
            })
        )
            .subscribe((res: any) => {
                if (res && res.data) {
                    this.loadFormWithData(res.data);
                } else {
                    // Handle error or unexpected response format
                }
            });
    }

    loadFormWithData(data: any) {
        this.form.patchValue({ ...data });
    }

    closeDialog() {
        this.dialogRef ?.close({ success: false });
    }

    submitForm() {
        if (!this.form.valid) return;

        this.isLoading = true;
        const payload = this.form.value;

        this.clientModulesService.updateClientModule(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err: any) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(helper.dialogConfig.headers.errorAtentie, msg, this.errorIcon);
                },
            });
    }
}
